// extracted by mini-css-extract-plugin
module.exports = {"content":"not-found-page_content__Khifo","container":"not-found-page_container__jixc8","title":"not-found-page_title__spuGI"};